import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, timeout, catchError, retry } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { deviceService } from '../services-hardware/deviceService';
import { AlertService } from './alert.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class GetJsonObjectService {
  constructor(
    private http: HttpClient,
    private alertService: AlertService,
    private deviceService: deviceService,
  ) {}

  public dataOutput: any;

  getJson(url: string, responseType?: string, paramInput: any = null, selfCatchError: boolean = true): Observable<any> {
    let option: any = {};
    if (responseType != null) option['responseType'] = responseType as 'json';
    if (paramInput == null) option['params'] = null;
    else option['params'] = paramInput;
    if (url != '') {
      return this.http.get<any>(url, option).pipe(
        retry(1),
        map((data: any) => {
          return data;
        }),
        catchError((e) => {
          if (selfCatchError) {
            return new Observable((observer) => {
              console.log('e : ', e);
              if (e.error?.title != null)
                this.alertService.error({
                  subType: '',
                  message: e.error?.title + ' (' + e.error?.detail + ') type error : ' + e.error?.status,
                });
              observer.next(e);
              observer.complete();
            });
          } else {
            return new Observable((observer) => {
              observer.next(e);
              observer.complete();
            });
          }
        }),
      );
    } else
      return new Observable((observer) => {
        observer.next(null);
        observer.complete();
      });
  }
}
